import { resolveRoute } from "./routes";

export function App() {
  const path = window.location.pathname;
  const Page = resolveRoute(path);
  return <Page />;
}
